export enum Route {
  Login = "login",
  Register = "register",
  RegisterSuccess = "register-success",
  Home = "",
  Upload = "upload",
  UploadCSV = "upload-csv",
  Dashboard = "dashboard",
  Users = "users",
  Tokens = "tokens",
  FeatureToggles = "feature-toggles",
  BusinessSettings = "business",
}
